import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import store from "@/store/";

var WS_BASE_URL = "/signalr/iot";
"#if TARGET === 'development'"
WS_BASE_URL = "https://localhost:44307/signalr/iot";
// WS_BASE_URL = "https://tone-generator.azurewebsites.net/signalr/iot";
"#endif"

var VueSignalRPlugin = {};

VueSignalRPlugin.install = function(Vue) {

  Vue.$startIoTSignalR = async function() {
    try {
      this.$log.info('Creating the HubConnection iot channel...'); 
      let hubConnection = new HubConnectionBuilder()    
          .withUrl(WS_BASE_URL)
          .configureLogging(LogLevel.Information)
          .withAutomaticReconnect()
          .build();
      
      await hubConnection.start();
      store.commit("mIoTSignalRConnectionOpen", hubConnection);      
      this.$log.info('HubConnection iot channel created');
      
      let firstKeepalive = true;
      let firstSensor = true;
      let firstSae = true;
      let firstAlarm = true;
      let firstAutomaticSnapshot = true;
      let _this = this;

      hubConnection.on('OnKeepalive', function (deviceId, timestamp, data) {
        if (firstKeepalive) {
          _this.$log.debug('OnKeepalive iot channel deviceId', deviceId)
          _this.$log.debug('OnKeepalive iot channel timestamp', timestamp)
          _this.$log.debug('OnKeepalive iot channel data', data)
          firstKeepalive = false
        }
        store.commit("mIoTSignalRKeepalive", {deviceId, timestamp, data})
      })

      hubConnection.on('OnSensorsData', function (deviceId, timestamp, data) {
        if (firstSensor) {
          _this.$log.debug('OnSensorsData iot channel deviceId', deviceId)
          _this.$log.debug('OnSensorsData iot channel timestamp', timestamp)
          _this.$log.debug('OnSensorsData iot channel data', data)
          firstSensor = false
        }
        store.commit("mIoTSignalRSensors", {deviceId, timestamp, data});
      })

      hubConnection.on('OnSAEData', function (deviceId, timestamp, data) {
        if (firstSae) {
          _this.$log.debug('OnSAEData iot channel deviceId', deviceId)
          _this.$log.debug('OnSAEData iot channel timestamp', timestamp)
          _this.$log.debug('OnSAEData iot channel data', data)
          firstSae = false
        }
        store.commit("mIoTSignalRSae", {deviceId, timestamp, data});
      })

      hubConnection.on('OnAlarmData', function (deviceId, timestamp, data) {
        if (firstAlarm) {
          _this.$log.debug('OnAlarmData iot channel deviceId', deviceId)
          _this.$log.debug('OnAlarmData iot channel timestamp', timestamp)
          _this.$log.debug('OnAlarmData iot channel data', data)
          firstAlarm = false
        }
        store.commit("mShowWarningMessage", { deviceId, data });
      })

      hubConnection.on('OnAutomaticSnapshot', function (deviceId, timestamp, data) {
        if (firstAutomaticSnapshot) {
          _this.$log.debug('OnAutomaticSnapshot iot channel deviceId', deviceId)
          _this.$log.debug('OnAutomaticSnapshot iot channel timestamp', timestamp)
          _this.$log.debug('OnAutomaticSnapshot iot channel data', data)
          firstAlarm = false
        }
        store.commit("mIotSignalRAutomaticSnapshot", { deviceId, timestamp, data });
      })
    } catch(e) {
      this.$log.error("Create HubConnection iot channel failure: " + e.message);  
    }
  };

  Vue.$stopIoTSignalr = async function() {
    try {
      let hubConnection = store.state.iotSignalR.hubConnection
      await hubConnection.stop()
      store.commit("mIoTSignalRConnectionClose");
      this.$log.info('HubConnection iot channel stopped');
    } 
    catch(e) {
      this.$log.error("Disconnect HubConnection iot channel failure: " + e.message); 
    }
  }

}

export default VueSignalRPlugin;